import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExternalInstanceComponent } from './external-instance.component';
import { ExternalInstanceDetailsComponent } from './external-instance-details/external-instance-details.component';
const routes: Routes = [
  {
    path: '',
    component: ExternalInstanceComponent,
    title: 'External Environment'
  },
  {
    path: ':instanceId',
    component: ExternalInstanceDetailsComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExternalInstanceRoutingModule {

 }
